import { render, staticRenderFns } from "./Bouquets.vue?vue&type=template&id=3b4ebf28&scoped=true"
import script from "./Bouquets.vue?vue&type=script&lang=js"
export * from "./Bouquets.vue?vue&type=script&lang=js"
import style0 from "./Bouquets.vue?vue&type=style&index=0&id=3b4ebf28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ebf28",
  null
  
)

export default component.exports